export const CONSTANT = "CONSTANT";

export const UPDATE_CART = "UPDATE_CART";
export const UPDATE_COUNT = "UPDATE_COUNT";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";

export const SET_DELIVERY_DETAILS = "SET_DELIVERY-DETAILS";

export const CLEAR_ALL_STATE_DATA = "CLEAR_ALL_STATE_DATA";

export const REQUEST_SIGNUP_START = "REQUEST_SIGNUP_START";
export const REQUEST_SIGNUP_SUCCESS = "REQUEST_SIGNUP_SUCCESS";
export const REQUEST_SIGNUP_FAIL = "REQUEST_SIGNUP_FAIL";

export const REQUEST_LOGIN_START = "REQUEST_LOGIN_START";
export const REQUEST_LOGIN_SUCCESS = "REQUEST_LOGIN_SUCCESS";
export const REQUEST_LOGIN_FAIL = "REQUEST_LOGIN_FAIL";

export const SIGNOUT = "SIGNOUT";

export const CHECK_AUTH_STATE = "CHECK_AUTH_STATE";

export const GET_FIREBASE_USER_DATA_START = "GET_FIREBASE_USER_DATA_START";
export const GET_FIREBASE_USER_DATA_SUCCESS = "GET_FIREBASE_USER_DATA_SUCCESS";
export const GET_FIREBASE_USER_DATA_FAIL = "GET_FIREBASE_USER_DATA_FAIL";

export const GET_USER_DOCUMENT_START = "GET_USER_DOCUMENT_START";
export const GET_USER_DOCUMENT_SUCCESS = "GET_USER_DOCUMENT_SUCCESS";
export const GET_USER_DOCUMENT_FAIL = "GET_USER_DOCUMENT_FAIL";

export const UPDATE_EMAIL_START = "UPDATE_EMAIL_START";
export const UPDATE_EMAIL_SUCCESS = "UPDATE_EMAIL_SUCCESS";
export const UPDATE_EMAIL_FAIL = "UPDATE_EMAIL_FAIL";

export const UPDATE_PASSWORD_START = "UPDATE_PASSWORD_START";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";
